import React from 'react';
import PropTypes from 'prop-types';
import { GeneralDialog } from 'sharedComponents/GeneralDialog';
import { IconHelpCircle } from 'svgIcons/MotionPortalIcons';
import { translate } from 'helpers/translateHelper';

const TrendCommentsHelpModal = ({ isOpen, onClose }) => {
    return (
        <GeneralDialog
            show={isOpen}
            close={onClose}
            title={
                <div className='comment-help-title'>
                    <IconHelpCircle />
                    <span>{translate('ABB.Powertrain.Frontend.opTrendCommentsHelpModalTitle')}</span>
                </div>
            }
            modalClassName='comment-help-dialog'
            backdropClassName='comment-help-backdrop'
            acceptButtonProps={{
                text: translate('ABB.Powertrain.Frontend.closeBtnLbl'),
                onClick: onClose
            }}
            closeButton={true}
        >
            <div className='comment-help-content'>
                <p>{translate('ABB.Powertrain.Frontend.commentHelpAddMethods')}</p>
                <div>
                    <span className='title'>{translate('ABB.Powertrain.Frontend.commentFromTrendGraph')}</span>
                    <ol>
                        <li>{translate('ABB.Powertrain.Frontend.opTrendCommentPoint1')}</li>
                        <li>{translate('ABB.Powertrain.Frontend.opTrendCommentPoint2')}</li>
                        <li>{translate('ABB.Powertrain.Frontend.opTrendCommentPoint3')}</li>
                    </ol>
                </div>
                <div>
                    <span className='title'>{translate('ABB.Powertrain.Frontend.commentFromCommentsPanel')}</span>
                    <p>{translate('ABB.Powertrain.Frontend.opTrendCommentPoint4')}</p>
                </div>
            </div>
        </GeneralDialog>
    );
};

TrendCommentsHelpModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
};

export default TrendCommentsHelpModal;
